import React, { PropsWithChildren } from "react";
import "./AmpLoadingSpinner.css";

interface AmpLoadingSpinnerProps extends PropsWithChildren {
    loading: boolean
}

export default function AmpLoadingSpinner(props: AmpLoadingSpinnerProps): JSX.Element {
    return (
        <div className="spinner-container">
            {props.children}
            <div className={`loading-spinner-parent ${props.loading ? "" : "not-loading"}`}>
                <div className={props.loading ? "loading-spinner" : ""}>
                </div>
            </div>
        </div>
    );
}
